import React from "react";

export default function Header({ toggleSidebar, username }) {
    return (
        <nav
            className="navbar shadow p-0"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "40px", // Висота хедера
                zIndex: 1000,
            }}
        >
            <div
                className="container-fluid d-flex justify-content-between align-items-center"
                style={{
                    height: "100%", // Вирівнюємо контент по висоті
                    position: "relative",
                }}
            >
                <div className="nav--logo--img" style={{ height: "100%" }}></div>
                <div
                    className="m-0"
                    style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        fontSize: "1.15rem", // Менший розмір шрифту для адаптації
                        lineHeight: "40px", // Вирівнюємо текст по центру вертикально
                    }}
                >
                    {username}
                </div>
                <button
                    className="navbar-toggler border-0 p-0"
                    onClick={toggleSidebar}
                    style={{
                        height: "40px", // Висота кнопки під розмір хедера
                        width: "40px",  // Ширина кнопки
                    }}
                >
                    <i className="bi bi-list" style={{ fontSize: "2rem" }}></i>
                </button>
            </div>
        </nav>
    );
}
